module.exports = __webpack_public_path__ + "static/media/nft-card-cryptogirl.b5c8fcf0.png";